<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="98">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="投保公司">
                            <Input v-model.trim="params.applicantInfo" clearable placeholder="请输入投保公司" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="投保单编号">
                            <Input v-model.trim="params.applicationNo" clearable placeholder="请输入投保单编号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="投保单状态">
                            <Select v-model="params.insuranceApplicationStatus" clearable>
                                <Option v-for="(item,index) in list" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="24" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/broker/insurance/application/pageList.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item name="查看详情" @click.native="toDetail(row)" style="text-align: center;">
                                <a>查看详情</a>
                            </Dropdown-item>
                            <Dropdown-item @click.native="toEdit(row)" style="text-align: center;">
                                <a>
                                    {{statusShow(row)?'编辑':'重新投保'}}
                                </a>
                            </Dropdown-item>
                            <!-- 大地雇主、人保雇主、平安雇主、国寿雇主 -->
                            <!-- <Dropdown-item v-if="row.applicationStatus=='FINISHED'" @click.native="uploadForm(row)" style="text-align: center;">
                                <a>上传投保单</a>
                            </Dropdown-item> -->
                        </Dropdown-menu>
                    </Dropdown>
                </template>
            </i-table>
        </div>
        <Modal
            v-model="modal"
            title="上传投保单"
        >
            <Form :label-width="100" class="mt15">
                <FormItem label="下载模板：">
                    <a @click="download" target="_blank">下载投保单</a>
                </FormItem>
                <FormItem label="盖章投保单：">
                    <Form class="policy" :model="form" ref="form" :label-width="0">
                        <Form-item 
                            class="policy-item" 
                            v-for="(p,i) in form.fileList"
                            :prop="'fileList.' + i + '.fileUrl'"
                            :key="i"
                            :rules="{required:true,message:'请上传投保单',trigger:'change'}">
                            <UploadImg 
                                v-model="p.fileUrl" 
                                @on-remove="removeImg(i)"
                                @on-success="val=>{uploaded(val, i)}"
                                :show-del="form.fileList.length>1" />
                            <Input v-model="p.fileUrl" v-show="false"></Input>
                        </Form-item>
                        <div class="policy-item" v-if="form.fileList.length<15">
                            <a @click="add">添加投保单</a>
                        </div>
                    </Form>
                </FormItem>
            </Form>
            <template slot="footer">
				<Button type="text" @click="cancel">取消</Button>
				<Button type="primary" @click="handleSubmit">确定</Button>
			</template>
        </Modal>
    </div>
    </template>
    <script>
    import { mapState } from 'vuex'
    import ITable from '../../../companyGroupEmployerDadi/common/ITable'
    import UploadImg from '../../../companyGroupEmployerDadi/common/UploadImg'
    export default {
        components:{ ITable,UploadImg },
        data () {
            return {
                loading: false,
                params: {
                    bizId:'INDUSTRY_ENTERPRISE',
                    insuranceApplicationStatus:'',
                    applicationNo:''
                },
                columns: [
                    {title:'投保单编号',key:'applicationNo',width: 260,fixed: 'left'},
                    {title:'投保单创建时间',key:'createTime',width: 180},
                    {title:'投保公司名称',key:'applicantName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'投保单状态',key:'applicationStatusDesc',minWidth: 120},
                    {title:'产品名称',key:'productName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保险公司',key:'companyName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保费（元）',key:'premium',width: 120,align: 'right'},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 90,
                        align: 'center',
                        fixed: 'right'
                    }
                ],
                list:[
                    {
                        value: 'UNCONFIRMED',
                        label: '待确认'
                    },
                    {
                        value: 'QUOTING',
                        label: '报价中'
                    },
                    {
                        value: 'QUOTE_REJECTED',
                        label: '报价失败'
                    },
                    {
                        value: 'CONFIRMED',
                        label: '已确认'
                    },
                    {
                        value: 'REVIEWING',
                        label: '核保中'
                    },
                    {
                        value: 'REVIEWED_REJECTED',
                        label: '核保失败'
                    },
                    {
                        value: 'ISSUING',
                        label: '出单中'
                    },
                    {
                        value: 'FINISHED',
                        label: '已完成'
                    },
                    {
                        value: 'REJECTED',
                        label: '已拒保'
                    },
                    {
                        value: 'CANCELLED',
                        label: '已作废'
                    }
                ],
                modal:false,
                form:{
                    fileList:[{
                        fileUrl:''
                    }]
                }
            }
        },
        computed:{
            ...mapState({
                channelId: state=>state.common.channelInfo.id,
            })
        },
        created () {
        },
        methods:{
            uploaded(file, index){
                let obj = {
                    fileUrl:file.url,
                    fileName:file.name,
                    fileType:'APPLICATION'
                }
                this.$set(this.form.fileList, index, obj);
            },
            add () {
                this.form.fileList.push({
                    fileUrl:''
                })
            },
            removeImg (i) {
                this.form.fileList.splice(i,1);
            },
            uploadForm(row){
                this.modal = true;
                this.$nextTick(()=>{
                    this.form = this.jsonCopy(row);
                    this.$set(this.form,'fileList',[{
                        fileUrl:''
                    }])
                })
            },
            cancel(){
                this.modal = false;
                this.form = {
                    fileList:[{
                        fileUrl:''
                    }]
                }
            },
            async handleSubmit(){
                let flag = await this.$refs.form.validate();
                if(!flag){
                    this.toast('请上传投保单','error');
                    return
                }
                this.$axios.post('/broker/attachment/uploadAttachmentFile.json.all',{
                    bizId:this.form.bizId,
                    productCode:this.form.productCode,
                    applicationId:this.form.insuranceApplicationId,
                    fileList:this.form.fileList
                }).then(res=>{
                    this.$Message.success('上传成功')
                    this.cancel();
                    this.tabChange();
                })
            },
            /*上传成功后获取数据*/
            uploadSuccess(res) {
                this.personList = res;
                this.openPersonList();
            },
            // 下载模板
            download() {
                this.$axios.post('/broker/export/exportApplication.json',{
                    bizId: this.form.bizId,
                    productCode: this.form.productCode,
                    applicationId: this.form.insuranceApplicationId
                }).then(res=>{
                    if(res){
                        this.getBlob(res).then((blob) => {
                            this.saveAs(blob, '投保单')
                        })
                    }
                })
            },
            getBlob(url) {
                return new Promise((resolve) => {
                    const xhr = new XMLHttpRequest()
                    xhr.open('GET', url, true)
                    xhr.responseType = 'blob'
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            resolve(xhr.response)
                        }
                    }
                    xhr.send()
                })
            },
            // 自定义下载文件名称
            saveAs(blob, filename) {
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename)
                } else {
                    const link = document.createElement('a')
                    const body = document.querySelector('body')

                    link.href = window.URL.createObjectURL(blob) // 创建对象url
                    link.download = filename

                    // fix Firefox
                    link.style.display = 'none'
                    body.appendChild(link)

                    link.click()
                    body.removeChild(link)

                    window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
                }
            },
            statusShow(row){
                return row.applicationStatus=='UNCONFIRMED'|| row.applicationStatus=='QUOTING'||row.applicationStatus=='QUOTE_REJECTED'||row.applicationStatus=='REVIEWING'||row.applicationStatus=='REVIEWED_REJECTED'
            },
            tabChange(){
                this.$refs.table.getList()
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedCCIC/insuranceDetail/${row.applicationNo}`
                })
            },
            toEdit(row){
                // 待确认 核保中 核保失败 询价成功 询价中
                if(this.statusShow(row)){
                    sessionStorage.removeItem("track_session_key")
                    this.$router.push('/companyGroupEmployerDadi/confirm/'+row.insuranceApplicationId);
                } else {
                    this.$router.push({
                        path:`/companyGroupEmployerDadi/fillin/${row.applicationNo}?productCode=${row.productCode}&productName=${row.productName}&reset=NEW`
                    })
                }
            },
            toPay(row){
                window.location.href=`/common.html#/payCCIC?orderNo=${row.orderNo}&productCode=${row.productCode}`
            },
            cancelOrder(row){
                this.$axios.post('/broker/order/close.all',{
                    orderNo: row.orderNo
                }).then(res=>{
                    if(res.code==10000000){
                        this.$Message.success('操作成功')
                        this.$refs.table.getList()
                    }
                })
            }
        }
    };
</script>
<style lang="less" scoped>
    .policy{
		display:flex;
        flex-wrap: wrap;
	}
	.policy-item{
		margin-right: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/insurance/index.vue